import EditQualificationQuestions from './EditQualificationQuestions.component';

export default EditQualificationQuestions;
